'use strict';
/**
 * Some useful packages (you can install by using npm)
 * 2. slick-carousel (pre-installed) = Simple, easy, responsive carousel (buggy centerMode - variableWidth - lazyMode)
 * 3. jquery-match-height (pre-installed) = Use this to match the height of elements. Either use this or Equalizer from Foundation
 * 4. bootstrap-select (pre-installed) = if you need custom dropdown
 *
 * IMPORTANT:
 * To import async-ly, you need to wrap your codes in require.ensure([], () => { });
 * It's best not to async plugins, to leverage browser cache
 * Ref: https://webpack.js.org/guides/code-splitting/
 *
 * NOTES:
 * This boilerplate uses CDN/external for jQuery package. Configured in gulp/webpack.js.
 * This to prevent the needs of jQuery from node_modules
 */

///////////////
// Libraries //
///////////////
import ssm from 'simplestatemanager';
import mh from 'jquery-match-height';
import JSON5 from 'json5';
import bootstrap from '../../node_modules/bootstrap-sass/assets/javascripts/bootstrap.min';
import scrollspy from '../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/scrollspy';
import FocusOn from './partials/focuson';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes';
import 'simple-scrollbar';
import debounce from 'raf-throttle';
import modernizrCustom from './components/modernizr-custom';
import ScrollTo from './partials/ScrollTo';



// window.modObFit = modernizrObjectFit;

// import objectFitImages from 'object-fit-images';

/////////////
// Plugins //
/////////////
import Cookies from 'js-cookie';
window.Cookies = Cookies;

////////////////
// Components //
////////////////


// Setting Webpack public path dynamically so that it loads the partials
// from the folder where the main.js is located
// var bundleSrc = $('[src$="./main.js"]').attr("src");
__webpack_public_path__ = "/www_shared/assets/js/";


// controlling functionality for mobile/tablet/desktop
window.currSmall = false;
window.currBig = false;

$(() => {


	///////////////////////////
	// Set default screen size manually for initial load
	///////////////////////////
	var $widthTest = $(window).outerWidth() > 991;
	if (!!$widthTest) {
		currBig = true;
	} else if (!$widthTest) {
		currSmall = true;
	};
	///////////////////////////

    require('./partials/custom-matchheight');
    require('./partials/lang-change');
	require('./partials/nav-menu');

	// Home
	if ($('.c-content__home-wrapper').length > 0) {
		require.ensure([], () => {
			require('./partials/home-page.js')($);
		}, 'home-page');
	}

	if ($('.sidebar .sidebar-menu').length > 0) {
		require.ensure([], () => {
			require('./partials/side-menu.js');
		}, 'side-menu');
	}

	if ($("[get-resources-by-country]").length > 0) {
		require.ensure([], () => {
			require('./partials/country-resources.js')($);
		}, 'country-resources');
	}

	if ($("[course-comparison-table]").length > 0) {
		require.ensure([], () => {
			require('./partials/course-comparison.js')($);
		}, 'course-comparison');
	}

	if ($(".pathways-parent-container").length > 0) {
		require.ensure([], () => {
			require('./partials/pathways.js')($);
		}, 'pathways');
	};

	if ($(".c-content__home-banner > .image-slider__wrapper").length > 0) {
		$(".c-content__home-banner > .image-slider__wrapper")
			.on('click',
				'.slick-slide button',
				function(){
					var $direction = ".slick-" + $(this).data('id');
					$(".c-content__home-banner > .image-slider__wrapper .o-slider__arrows").find($direction).click();
				});
	};

	// channel partners
	if ($('.channel-partners-container').length > 0) {
		require.ensure([], () => {
			require('./partials/channel-partners.js')($);
		}, 'channel-partners');
	};

	if ($('[ng-list-container]').length > 0) {
		require.ensure([], () => {
			require('./components/angular.min.js');
			require('./components/angular-route.min.js');
			require('./partials/ng-listing.js')($);
		}, 'ng-listing');
	};

	if ($('[data-slickjs]').length > 0) {
		require.ensure([], () => {
			require('./components/slick-js-ctrl.js')($);
		}, 'slick-js-ctrl');
	};

	////////////////
	// Scroll To //
	////////////////
	let $scrollTo = $('[data-scrollto]');
	if ($scrollTo.length) {
		new ScrollTo($scrollTo);
	}


	 //////////////////
	// Init Toggler //
	//////////////////
	let $jsVtoggle = $('[data-vtoggle]');
	$jsVtoggle.each(function(){
		let $this = $(this);
		let { key, selfClass, class:cls, target, event:ev, transitionProperty, removeClass, isAddClass } = JSON5.parse($this.attr('data-vtoggle'));

		$this.on(ev || 'click', function() {
			let $this = $(this);

			if(cls){
				let $target = $(target);
				const TRANSITION_EVENT = 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend';
				const LOADING_CLASS = `${cls}-is-loading`;

				if(!isAddClass){
					$target.toggleClass(cls);
				} else{
					$target.addClass(cls);
				}

				if(transitionProperty){
					$target
						.addClass(LOADING_CLASS)
						.one(TRANSITION_EVENT, function(e){
							if(transitionProperty == e.originalEvent.propertyName){
								let $this = $(this);
								$this.removeClass(LOADING_CLASS);
							}
						});
				}

				if(removeClass){
					$target.removeClass(removeClass);
				}
			}

			if(selfClass){
				$this.toggleClass(selfClass);
			}
		});
	});

	/////////////
    // FocusOn //
    /////////////
    let $focusOn = $('[data-focuson]');
    if ($focusOn.length) {
        require.ensure([], () => {
            const FocusOn = require('./partials/focuson');
            new FocusOn($focusOn);
        }, 'focuson');
	}

	const $stickySubscriber = $('[data-stickysubscriber]');
	if($stickySubscriber.length){
		require.ensure([], function(){
			const stickSub = require('./partials/sticky-subscriber');
			stickSub($stickySubscriber);
		}, 'sticksubscriber')
	}

    //////////////
    // Searcher //
    //////////////
    ///
    /// Put this on the input[type]
    /// params:
    /// - buttonSelector (String): is the selector of the button that should trigger the search
    /// - url: the search url, e.g. search?q=
    const $searcher = $('[data-searcher]');
	$searcher.each(function(){
		const $this = $(this);
    	const { buttonSelector, url } = JSON5.parse($this.attr('data-searcher'));

    	$this.on('keyup', function(e){
    		e.preventDefault();
    		if(e.which == 13){
    			document.location.href= `${url}${$this.val()}`;
    		}
    		return false;
    	});

    	$(buttonSelector).on('click', function(){ document.location.href= `${url}${$this.val()}`; });
	});

	/////////////////////
	// Lazy Load video //
	/////////////////////
	$('.video-embed-field-lazy').click(function(e) {
        // Swap the lightweight image for the heavy JavaScript.
        e.preventDefault();
        var $el = $(this).addClass('is-active');
        $el.html($el.data('video-embed-field-lazy'));
	});

	////////////////////////////
	// Banner Title Length
	////////////////////////////
	// Detect if text over flows the banner background - change width to AUTO if it does
	if ($('.header__text').length > 0) {

		var TextOverflow = {
			crop: function(elm) {
				var w = elm.width(),
				t = elm.text(),
				child;

				elm.html('<span>'+t+'</span>');
				child = elm.children(":first-child");
				if(child.width() > w) {
					return true;
				} else {
					return false;
				}
			}
		};

		const adjustStyleIfHeaderTextIsOverflow = ()=>{

			if (currBig) {
				var isOver = TextOverflow.crop($('.header__text h1'));
				if (isOver) {
					$(".header__text").attr("style", "width: auto !important");
				}
			} else if (currSmall) {
				$(".header__text").attr("style", "");
			}
		}

		$(window).on('resize', debounce(function(){
			adjustStyleIfHeaderTextIsOverflow();
		}, 20, true));

		adjustStyleIfHeaderTextIsOverflow();
	};

	/////////////////////////////////
	// Online Enquiry Form Submit
	/////////////////////////////////
	if ($('[online-enquiry-form]').length > 0 || $('[data-intl-tel-input]').length > 0) {
		require.ensure([], () => {
			require('./partials/intTelInputCtrl')($);
		}, 'intlTelInputScripts');
	}

	$("[data-module").each(function() {
		const $module = $(this)
		require.ensure([], () => {
			const moduleName = $module.data('module')
			const opts = JSON5.parse($module.attr('data-module-options') || '{}')
			require("./modules/" + moduleName + '.js')($module, opts);
		}, 'module-loaders')
	});


		if (!Modernizr.objectfit) {
			$('.slick-slide, .banner__image, .video-embed-field-lazy, .promo__image, .promo__media, .promo__video').each(function () {
			  var $this = $(this),
			  	  $container = $($this),
				  imgUrl = $container.find('img').attr('data-src');

				if (typeof imgUrl === 'undefined') {
					imgUrl = $container.find('img').attr('src');
				};

			  if (!!imgUrl) {
				$container
				  .css('backgroundImage', 'url(' + imgUrl + ')')
				  .addClass('object-fit-poly');
			  }
			});
		  }

	// Tab linking button
	$(document)
		.on('click',
			'[tab-link-btn]',
			function(e){
				e.preventDefault();
				var $tabId = '#compare-title-' + $(this).data('tab-id'),
					$scrollHeight = $($tabId).offset().top - $('#block-mainnavigation').outerHeight() - 30;
				$('body,html').animate({
					scrollTop: $scrollHeight + 'px'
				}, 500);
				$($tabId).click();
			});

	// // Promo tile caption heights
	// $(document).ready(function(){
	// 	// if page has promo links to resize
	// 	if ($('.promo__link').length > 0) {
	// 		// loop over the parents
	// 		$('.flex-tile').each(function(){
	// 			// only care if that parent actually has promo links, might be others on the page
	// 			if ($(this).find('.promo__link').length > 0) {

	// 			}
	// 		})
	// 	}
	// });


	// Location Map
	if ($('.c-location-map').length) {
		require.ensure([], () => {
			require('./partials/location-map-widget.js')($);
		}, 'location-map');
	};


	// fix sidebar call to action
	const $flycta = $(".c-fly-cta:not(.c-fly-cta--updated)");
    if ($flycta.length) {
        var countcta = $('.c-fly-cta__items>li').length
        console.log(countcta);
        if(countcta < 2){
        	$flycta.addClass('is-1')
        } else if(countcta == 2){
        	$flycta.addClass('is-2')
        } else if(countcta > 2){
        	$flycta.addClass('is-3')
        }
    }


	///////////////////////////////
	// Video Banner Button
	///////////////////////////////
	$(document)
		.on('click', '.video-banner-button', function(evt){
			evt.preventDefault();
			const $this = $(this);
			const $url = $this.attr('href');
			function parser(url) {
				var regExp =
					/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\/)|(\?v=|\&v=))([^#\&\?]*).*/;
				var match = url.match(regExp),
					val = match[8];
				if (match && val.length == 11) {
					if (val[0] === '-') {
						val = val.substr(1);
						return String(val);
					} else {
						return String(val);
					}
				}
			};

			var $html =
			$(`
				<div class="modal video-banner-modal">
					<div class= "modal-body">
						<div class="close">
							<span class="g-icon-cross"></span>
						</div>
						<div class="u-embed u-embed--16by9">
							<iframe class="u-embed__item" src="https://www.youtube.com/embed/${parser($url)}"></iframe>
						</div>
					</div>
					<div class="modal-background"></div>
				</div >
			`);
			$('body').append($html);
		})
		.on('click', '.video-banner-modal .close, .video-banner-modal .modal-background', function (evt) {
			evt.preventDefault();
			$('.video-banner-modal').remove();
		});

		if (!!$('.uploader-main')) {

			var parents = document.querySelectorAll('.uploader-main .uploader-upload');

			parents.forEach(element => {
				let $element = $(element),
						$elem = $element.find('input'),
						id = $elem.attr('id');
				$elem.addClass('u-dn');
				$element.wrapInner(`<label class="c-file-uploader" data-file="Choose file" for="${id}"></label>`);
			});

			$(document).on('change', '.uploader-main input', function (evt) {
					let files = evt.target.files;

					// Check there are files, otherwise it throws an error
					if (files.length > 0) {
						let title = files[0].name,
							elem = $(evt.target).closest('.c-file-uploader');

							// If title is long then choppy choppy
							if (title.length > 38) {
								// Cut the string
								let temp = title.slice(0, 37);
								// stick ellipsis on the end so its obvious what is happening
								temp += '...';
								title = temp;
							}

							elem.attr('data-file', title);
					}
				});
		}

	// collapse event
	const $collapseEventEl = $('[data-collapseevents]');
	if($collapseEventEl.length) {

		require.ensure(
			[],
			() => {
				const collapseEventFn = require("./partials/collapseevents");
				$collapseEventEl.each(function () {
					const $this = $(this)
					collapseEventFn(this, $this, JSON5.parse($this.attr('data-collapseevents')));
				});
			},
			"collapseevents"
		);
	}

	// toggle collapse
	const $toggleCollapseEl = $("[data-togglecollapse]");
	if ($toggleCollapseEl.length) {
		require.ensure(
			[],
			() => {
				const togglecollapseFn = require("./partials/togglecollapse");
				$toggleCollapseEl.each(function () {
					const $this = $(this);
					togglecollapseFn(
						this,
						$this,
						JSON5.parse($this.attr("data-togglecollapse"))
					);
				});
			},
			"togglecollapse"
		);
	}

	// expand parents
	const $expandParentsEl = $("[data-expandparents]");
	if ($expandParentsEl.length) {
		require.ensure(
			[],
			() => {
				const expandparentsFn = require("./partials/expandparents");
				$expandParentsEl.each(function () {
					const $this = $(this);
					expandparentsFn(
						this,
						$this,
						JSON5.parse($this.attr("data-expandparents"))
					);
				});
			},
			"expandparents"
		);
	}

    ssm.addStates([{
		id: 'width-small',
		query: '(max-width: 991px)',
		onEnter: () => {
			currBig = false;
			currSmall = true;
		},
		onLeave: () => {
		}
	}, {
		id: 'width-big',
		query: '(min-width: 992px)',
		onEnter: () => {
			currBig = true;
			currSmall = false;
		},
		onLeave: () => {
		}
	} ]);

});




// WEBPACK FOOTER //
// ./src/_js/main.js